export default class SectorModel {
  id?: number;
  name?: string;

  constructor(params: SectorModel) {
    this.id = params.id;
    this.name = params.name;
  }

  static fromJson(json: any): SectorModel {
    return new SectorModel({
      id: json?.id,
      name: json?.attributes?.name,
    });
  }
}
